module.exports = __webpack_public_path__ + "img/microphone-02.e2eebe98.svg";